import React, { useMemo } from 'react'
import { Typography, Card, CardContent } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn } from '@fortawesome/free-solid-svg-icons'
import parse from 'html-react-parser'
import { useFirestore } from '../../hooks/useFirestore'
import { SETTINGS_COLLECTION } from '../../_constants/globals'


const AnnouncementCard = () => {
  
  const settingHooks = useFirestore(SETTINGS_COLLECTION)
  const dbSettings = settingHooks.getDocs()
  
  const announcement = useMemo(() => dbSettings[0]?.announcement, [dbSettings])
  
  return announcement
    ? <Card sx={{ minWidth: '275px', mb: 2, p: 1 }}>
      <CardContent>
        <Typography variant='subtitle1' mb={1}>
          <FontAwesomeIcon icon={faBullhorn} style={{ verticalAlign: 'baseline' }}/> Annonce
        </Typography>
        <Typography variant='body1'>
          {parse(announcement)}
        </Typography>
      </CardContent>
    </Card>
    : null
}

export default AnnouncementCard
